<template>
  <v-container>
    <bread-crumbs :items="breadCrumbs"/>

    <v-card class="pt-8 mt-3">
      <h4 class="container-title">لیست رک
        {{titleExcel}}
      </h4>

      <v-card-text class="pa-5">
        <v-sheet elevation="4" v-if="rackListData" class="mt-5">
        <p class="pa-5"><span> نام مشتری:</span>
          <span>{{customerName}}</span>
        </p>
          <v-data-table
            id="exportTable"
            :headers="headers"
            :items="rackListData"
            :items-per-page="10"
            class="elevation-3"
            :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-plus',
        nextIcon: 'mdi-minus',
        itemsPerPageOptions:[10,15]
      }">
          </v-data-table>
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import CustomTextField from "@/components/base/CustomTextField";
import {thousandComma} from "@/plugins/helper";
export default {
  name: "contractList",
  components: {CustomTextField},
  data() {
    return {
      thousandComma,
      page: 1,
      totalUsers: 0,
      numberOfPages: 0,
      loading: true,
      options: {},
      confirmID: null,
      dialog: false,
      dialogConsult: false,
      dialogAdmin: false,
      totalDesserts: 0,
      desserts: [],
      breadCrumbs: [
        {
          text: "داشبورد",
          disabled: false,
          to: {name: "Dashboard"},
          exact: true,
        },
        {
          text: "لیست رک ",
          disabled: true,
          exact: true,
        },
      ],

      headers: [
        {text: "کد مشتري", value: "customer_code", sortable: true, align: 'center', width: '120px'},
        {text: 'Name', value: 'name', sortable: true, align: 'center', width: '220px'},
        {text: 'Status', value: 'status', sortable: true, width: '100px', align: 'center'},
        {text: 'Tenant', value: 'tenant', sortable: true, align: 'center', width: '220px'},
        {text: 'Role', value: 'role', sortable: true, width: '100px', align: 'center'},
        {text: 'Manufacturer', value: 'manufacturer', sortable: true, width: '150px', align: 'center'},
        {text: 'Type', value: 'type', sortable: true, align: 'center', width: '150px'},
        {text: 'Serial Number', value: 'serial_number', sortable: true, align: 'center', width: '150px'},
        {text: 'Site', value: 'site', sortable: true, align: 'center', width: '180px'},
        {text: 'Rack', value: 'rack', sortable: true, width: '100px', align: 'center'},
        {text: 'Position', value: 'position', sortable: true, width: '120px', align: 'center'},
        {text: 'Rack Face', value: 'rack_face', sortable: true, align: 'center', width: '120px'},
        {text: 'Airflow', value: 'airflow', sortable: true, align: 'center', width: '150px'},
      ],
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        },
        numberRule: (v) => {
          if (!v.trim()) return true;
          if (!isNaN(parseFloat(v)) && v >= 0) return true;
          return "لطفا عدد وارد نمائید";
        },
      },
      searchName: '',
      searchMobile: '',
      confirmMethod: null,
      confirmRole: '',
      introductionLetterUrl: '',
      lawDocumentUrl: '',
      confirmStateId: '',
      dialogState: false,
      dialogUserProfile: false,
      dialogNew: false,
      appName: '',
      appId: '',
      search_customer_name: '',
      search_customer_code: '',
      search_bill_number: '',
      search_bill_date: '',

      json_fields: {
        "شماره رک": 'rack',
        "شماره یونیت": 'unit',

      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],

      startDate: '',
      endDate: "",
      endDateDisable: true,
      titleExcel:'',


    };
  },

  computed: {
    rackListData: {
      get() {
        let data = this.$store.getters["company/getRacks"];
        this.titleExcel = data[0]?  data[0].customer_name : '';
        return data;
      },
      set(value) {
      },
    },

    excelTitle: {
      get() {
        return ` نام مشتری :${titleExcel}`
      },
      set(value) {
      },
    },
    fileName: {
      get() {
        return `rackList-${this.$route.params.id}`
        //return `${this.userProfile.firstName} ${this.userProfile.lastName}`
      },
      set(value) {
      },
    },
    customerName: {
      get() {
        return `${this.$route.params.name}`
        //return `${this.userProfile.firstName} ${this.userProfile.lastName}`
      },
      set(value) {
      },
    },

  },
  watch: {
    // options: {
    //   handler() {
    //     this.readDataFromAPI();
    //   },
    // },
    startDate: {
      handler() {
        if (this.startDate != "") {
          this.endDateDisable = false;
          this.endDate = "";
        } else {
          this.endDateDisable = true;
          this.endDate = "";
        }
      },
    },

  },
  async mounted() {
    await this.$store.dispatch('company/fetchRacks403',{customer_code:this.$route.params.id})
  },
  methods: {

    checkType(data) {
      return typeof data.item !== "object";
    },


    // async filter() {
    //   // this.convertDateToTimestamp(this.startDate),
    //   await this.$store.dispatch("company/fetchContracts", {
    //     bill_number :this.search_bill_number,
    //     start_date:this.convertDateToTimestamp(this.startDate),
    //     end_date:this.convertDateToTimestamp(this.endDate),
    //     customer_code:this.search_customer_code,
    //     customer_name:this.search_customer_name,
    //     bill_date:this.convertDateToTimestamp(this.search_bill_date),
    //   });
    // },

    resetForm(){

    },
    transformDateToJalali(value) {
      return moment(value).format('jYYYY/jMM/jDD')
    },
    convertDateToTimestamp(date) {
      return new Date(
        moment(date, "jYYYY/jMM/jDD").format("YYYY/MM/DD")
      ).getTime();
    },
    /**
     * In a real application this would be a call to fetch() or axios.get()
     */
  },
};
</script>

<style>
.v-text-field__slot input {
  color: black !important;
}

body {
  text-align: right;
}

td {
  /*color: black !important;*/
}
</style>
